import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BankNameService {
  constructor(private http: HttpClient) {}

  private bankNameJson: { [key: string]: any } = {};

  async initbankNameJson() {
    return lastValueFrom(
      this.http.get('assets/i18n/bank-name.json').pipe(
        map((res: any) => {
          this.bankNameJson = res || {};
          return res;
        })
      )
    );
  }

  get<T>(key: string): T {
    return localStorage.NG_TRANSLATE_LANG_KEY === 'en' ? (key as any) : this.bankNameJson[key] ?? key;
  }
}
